import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

export type MainProps = ComponentProps<'main'>;

export function Main({ className, ...props }: MainProps) {
  return (
    <main
      className={twMerge('min-h-screen-with-nav-bar', className)}
      {...props}
    />
  );
}
